import * as Immutable from 'immutable';
import {
  LIST_ADVISERS_REQUESTED,
  LIST_ADVISERS_COMPLETED,
  LIST_ADVISERS_FAILED,
  LIST_ADVISERS_ABORTED,
  RESET_ADVISER_LIST_REQUESTED,
  RESET_ADVISER_LIST_COMPLETED,
  RESET_ADVISER_REQUESTED,
  RESET_ADVISER_COMPLETED,
  SET_ADVISER_REQUESTED,
  SET_ADVISER_COMPLETED,
  // SET_ADVISER_ABORTED,
  SET_ADVISER_FAILED,
  SEARCH_ADVISERS_REQUESTED,
  SEARCH_ADVISERS_COMPLETED,
  SEARCH_ADVISERS_FAILED,
  GET_ADVISERS_USERS_ABORTED,
  GET_ADVISERS_USERS_REQUESTED,
  GET_ADVISERS_USERS_COMPLETED,
  GET_ADVISERS_USERS_FAILED,
  CREATE_ADVISERS_USER_REQUESTED,
  CREATE_ADVISERS_USER_COMPLETED,
  CREATE_ADVISERS_USER_FAILED,
  RESEND_ADVISERS_USER_REQUESTED,
  RESEND_ADVISERS_USER_COMPLETED,
  RESEND_ADVISERS_USER_FAILED,
  CHANGE_ADVISERS_EMAIL_REQUESTED,
  CHANGE_ADVISERS_EMAIL_COMPLETED,
  CHANGE_ADVISERS_EMAIL_FAILED,
  CHANGE_ADVISERS_PASSWORD_REQUESTED,
  CHANGE_ADVISERS_PASSWORD_COMPLETED,
  CHANGE_ADVISERS_PASSWORD_FAILED,
  RESET_ADVISERS_TOAST_COMPLETED,
  RESET_ADVISERS_TOAST_REQUESTED,
} from '../../actions/advisers/types';

const schema = {
  status: 'INIT', // INIT/OK/ERROR
  error: null,
  list: {},
  set: {},
  gettinglist: false,
  gotlist: false,
  gettingdata: false,
  gotdata: false,
  abortedlist: false,
  gettingusers: false,
  resendinguser: false,
  creatinguser: false,
  changingemail: false,
  changingpassword: false,
  admintoastmessage: false,
  resettingadviser: false,
  resettingadviserlist: false,
  resettingtoast: false,
  toastmsg: '',
  gotusers: false,
  users: {
    items: [],
  },
  searchTerm: '',
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ADVISERS_TOAST_REQUESTED:
      return state.set('resettingtoast', true);

    case RESET_ADVISERS_TOAST_COMPLETED:
      return state.set('admintoastmessage', false).set('toastmsg', '');

    case SET_ADVISER_REQUESTED:
      return state.set('gettingdata', true).set('set', null);

    case SET_ADVISER_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('set', action.payload);

    // case SET_ADVISER_ABORTED:
    //     return state
    //         .set('gettingdata', false)
    //         .set('gotdata', false);

    case SET_ADVISER_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case RESET_ADVISER_REQUESTED:
      return state.set('resettingadviser', true);

    case RESET_ADVISER_COMPLETED:
      return state.set('resettingadviser', false).set('set', {});

    case RESET_ADVISER_LIST_REQUESTED:
      return state.set('resettingadviserlist', true);

    case RESET_ADVISER_LIST_COMPLETED:
      return state.set('resettingadviserlist', false).set('list', {});

    case LIST_ADVISERS_REQUESTED:
      return state.set('error', null).set('gettinglist', true);

    case LIST_ADVISERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case LIST_ADVISERS_ABORTED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', false)
        .set('abortedlist', true);

    case LIST_ADVISERS_FAILED:
      return state.set('error', action.payload);

    case SEARCH_ADVISERS_REQUESTED:
      return state
        .set('error', null)
        .set('gettinglist', true)
        .set('searchTerm', action.payload.Search);

    case SEARCH_ADVISERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case SEARCH_ADVISERS_FAILED:
      return state
        .set('error', action.payload)
        .set('gettinglist', false)
        .set('list', {});

    case GET_ADVISERS_USERS_ABORTED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('users', { items: {} });

    case GET_ADVISERS_USERS_REQUESTED:
      return state.set('error', null).set('gettingusers', true);

    case GET_ADVISERS_USERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('gotusers', true)
        .set('users', action.payload);

    case GET_ADVISERS_USERS_FAILED:
      return state.set('error', action.payload);

    case CREATE_ADVISERS_USER_REQUESTED:
      return state
        .set('error', null)
        .set('gettingusers', true)
        .set('creatinguser', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '')
        .set('users', {});

    case CREATE_ADVISERS_USER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('creatinguser', false)
        .set('gotusers', true)
        .set('admintoastmessage', true)
        .set('toastmsg', 'Adviser User has been created')
        .set('users', action.payload);

    case CREATE_ADVISERS_USER_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', action.payload.errors[0].message)
        .set('gettingusers', false)
        .set('creatinguser', false)
        .set('gotusers', true)
        .set('error', action.payload);

    case RESEND_ADVISERS_USER_REQUESTED:
      return state
        .set('error', null)
        .set('gettingusers', true)
        .set('resendinguser', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '')
        .set('users', {});

    case RESEND_ADVISERS_USER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('resendinguser', false)
        .set('gotusers', true)
        .set('admintoastmessage', true)
        .set('toastmsg', 'Adviser User has been resent')
        .set('users', action.payload);

    case RESEND_ADVISERS_USER_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', action.payload.errors[0].message)
        .set('gettingusers', false)
        .set('resendinguser', false)
        .set('gotusers', true)
        .set('error', action.payload);

    case CHANGE_ADVISERS_EMAIL_REQUESTED:
      return state
        .set('error', null)
        .set('changingemail', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '');

    case CHANGE_ADVISERS_EMAIL_COMPLETED:
      return state
        .set('error', null)
        .set('changingemail', false)
        .set('admintoastmessage', true)
        .set('toastmsg', 'Adviser User email has been updated');

    case CHANGE_ADVISERS_EMAIL_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', action.payload.errors[0].message)
        .set('error', action.payload);

    case CHANGE_ADVISERS_PASSWORD_REQUESTED:
      return state
        .set('error', null)
        .set('changingpassword', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '');

    case CHANGE_ADVISERS_PASSWORD_COMPLETED:
      return state
        .set('error', null)
        .set('changingpassword', false)
        .set('admintoastmessage', true)
        .set('toastmsg', 'User password has been reset');

    case CHANGE_ADVISERS_PASSWORD_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', 'Unable to reset user password, please try again.')
        .set('error', action.payload);
    default:
      return state;
  }
};

export { initialState };

export default reducer;
